import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const CinematicSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      data-testid="cinematic-section"
      ref={ref}
      className="relative z-10 py-0"
    >
      <div className="relative min-h-[70vh] lg:min-h-[80vh] flex items-center justify-center cinematic-overlay overflow-hidden">
        {/* Background image */}
        <img
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxlYXJ0aCUyMGZyb20lMjBzcGFjZXxlbnwwfHx8fDE3NzU1ODUxNjF8MA&ixlib=rb-4.1.0&q=85"
          alt="Earth from space"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />

        {/* Content overlay */}
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-xs font-semibold tracking-[0.4em] uppercase text-cyanGlow mb-6"
          >
            Beyond Boundaries
          </motion.p>

          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
            className="metallic-text text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight leading-tight"
          >
            From Earth to the Moon and Mars
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-8 text-base lg:text-lg text-zinc-300 max-w-2xl mx-auto font-light leading-relaxed"
          >
            Mental resilience infrastructure designed to scale across
            gravitational environments. Wherever humanity goes, OASIS follows.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default CinematicSection;
